import initMap from './init-map';
import throttle from '../common/throttle';
import globalFunctions from "../common/global-functions"; 

const progressBar = require('nprogress');

let filters = {};
let subcategories = [];
let neighborhoods = [];
let addinfos = [];
if ($('#js-get-json-filter').val()){
    filters = JSON.parse($('#js-get-json-filter').val());
    subcategories = filters.subcategories;
    filters.subcategories = subcategories.join(',');
    neighborhoods = filters.neighborhoods;
    filters.neighborhoods = neighborhoods.join(',');
    addinfos = filters.addinfos;
    filters.addinfos = addinfos.join(',');
}

let multipleFilters = ['neighborhood', 'addinfo'];

$.each(multipleFilters, (key, parentItem) => {
    $.each($('.js-'+parentItem+'-child'), (key, item) => {
    let parentName = $(item).data(parentItem+'-parent');
    if (item.checked) {
        let parent = $('.js-'+parentItem+'-parent[data-'+parentItem+'-parent-name="' + parentName + '"]');
        parent.prop('checked', true);
    }
    });
});

$(document).on('click', '.js-category-pagination .pagination a', function (e) {
    e.preventDefault();

    if ($(this).data('page')) {
        filters.page = $(this).data('page');
    }
    getCategoryResults(filters);

});

$('.js-category-page').on('click', '.js-all-filters.js-sort-radio', function() {
    $(this).parents('.js-options').siblings('.js-sort-btn').removeClass('is-open');
});

$('.js-category-page').on('change', '.js-all-filters', function() {
    var $this = $(this);

    if ($this.data('field')) {
        filters.field = $this.data('field');
    }

    if ($this.data('dir')) {
        filters.dir = $this.data('dir');
    }

    if ($this.data('price')) {
        filters.price = (filters.price == $this.data('price')) ? '' : $this.data('price');
        filters.page = 1;
    }

    if ($this.data('subcategory')) {
        filters.page = 1;
        let searchSubcategory = subcategories.indexOf($this.data('subcategory').toString());

        if (searchSubcategory != -1) {
            subcategories.splice(searchSubcategory, 1);
        } else {
            subcategories.push($this.data('subcategory').toString());
        }
    }

    if ($this.data('neighborhood')
        && $this.data('neighborhood') != 'parent') {
            filters.page = 1;
            let searchNeighborhood = neighborhoods.indexOf($this.data('neighborhood').toString());

            if (searchNeighborhood != -1) {
                neighborhoods.splice(searchNeighborhood, 1);
            } else {
                neighborhoods.push($this.data('neighborhood').toString());
        }
    }

    if ($this.data('neighborhood') == 'parent') {
        let neibChild = $('.js-neighborhood-child');
        $.each(neibChild, (key, item) => {
            if ($(item).data('neighborhood-parent') == $.trim($this.data('neighborhood-parent-name'))) {
                if (this.checked) {
                    neighborhoods.push($(item).data('neighborhood').toString());
                } else {
                    neighborhoods = $.grep(neighborhoods, function(value){
                        return value != $(item).data('neighborhood');
                    });
                }
            }
        });
    }

    if ($this.data('addinfo')
        && $this.data('addinfo') != 'parent') {
            filters.page = 1;
            let searchAddInfo = addinfos.indexOf($this.data('addinfo').toString());

            if (searchAddInfo != -1) {
                addinfos.splice(searchAddInfo, 1);
            } else {
                addinfos.push($this.data('addinfo').toString());
        }

    }

   if ($this.data('addinfo') == 'parent') {
        let addInfoChild = $('.js-addinfo-child');
        $.each(addInfoChild, (key, item) => {
            if ($(item).data('addinfo-parent') == $.trim($this.data('addinfo-parent-name'))) {
                if (this.checked) {
                    addinfos.push($(item).data('addinfo').toString());
                } else {
                    addinfos = $.grep(addinfos, function(value){
                        return value != $(item).data('addinfo');
                    });
                }
            }
        });
    }

    if ($this.data('tips')) {
        filters.page = 1;
        filters.tips = $this.prop('checked') ? $this.data('tips') : '';
    }

    if ($this.data('rated')) {
        filters.page = 1;
        filters.rated = $this.prop('checked') ? $this.data('rated') : '';
    }

    filters.subcategories = subcategories.join(',');
    filters.neighborhoods = neighborhoods.join(',');
    filters.addinfos = addinfos.join(',');

    highlightActiveFilters(filters);
    getCategoryResults(filters);

});

$('.js-search-reset').on('click', function() {
    filters = {};

    highlightActiveFilters(filters);
    getCategoryResults(filters);
});

let streamCount = 0;

function getCategoryResults(filters) {
    progressBar.configure({ parent: '.js-category-content-results' });

    let recursiveEncoded = $.param(filters);
    let newString = location.pathname + '?' + recursiveEncoded;

    history.pushState(filters, '', newString);

    throttle.start(() => (
            $.ajax({
                url: window.location.href,
                type: 'GET',
                data: filters,
                beforeSend: function(xhr) {
                    ++streamCount;
                    progressBar.start();
                    initMap.emptyMap();
                    $('.js-sort-btn').prop('disabled', true);
                },
                success: function(data) {
                    --streamCount;
                    if (streamCount > 0) return;

                    $('.js-category-content__container-result').html(data);
                    $('.js-sort-btn').prop('disabled', false).removeClass('is-open');

                    setTimeout(function() {
                        var $img = $('.category-content__list.js-search-content .category-content__img img');
                        $img.on('load', globalFunctions.resizeProductResultsImagesDebounced);
                    }, 1);
                },
                error: function(req, text, error) {
                    --streamCount;
                    if (streamCount > 0) return;

                    let errors = [];
                    let response = {};
                    try {
                        response = req.responseJSON;
                        for (let prop in response.errors) {
                            errors.push(response.errors[prop]);
                        }
                    } catch (e) {}
                },
                complete: function() {
                    initMap.emptyMap();
                    initMap.setMarkers();

                    if (streamCount < 1) progressBar.done();
                }
            })
        ),
        1000
    );
}

function highlightActiveFilters(filters) {
    $.each($('.js-sort-paragraph'), function(index, value) {
        let hiddenRadio = $(this).next();
        if (hiddenRadio.data('dir') == filters.dir && hiddenRadio.data('field') == filters.field) {
            $(this).addClass('is-checked');
        } else {
            $(this).removeClass('is-checked');
        }
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/category/results-filter.js